import { render, staticRenderFns } from "./ManagerSchoolPicker.vue?vue&type=template&id=5630a6b8&scoped=true&"
import script from "./ManagerSchoolPicker.vue?vue&type=script&lang=js&"
export * from "./ManagerSchoolPicker.vue?vue&type=script&lang=js&"
import style0 from "./ManagerSchoolPicker.vue?vue&type=style&index=0&id=5630a6b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5630a6b8",
  null
  
)

export default component.exports